module.exports = __webpack_public_path__ + "ni.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/ni.svg
// module id = 987
// module chunks = 0